function switchPanel(tabs, panels, targetId) {
	tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.target === targetId));
	panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === targetId));
}

function initAuthTabs() {
	const root = document.querySelector('.js-auth');
	if (!root) {
		return;
	}

	const tabs = Array.from(root.querySelectorAll('.js-auth-tab'));
	const panels = Array.from(root.querySelectorAll('.js-auth-panel'));

	root.querySelectorAll('.js-auth-tab, .js-auth-switch').forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			switchPanel(tabs, panels, trigger.dataset.target);
		});
	});
}

function initUserTabs() {
	const root = document.querySelector('.js-user');
	if (!root) {
		return;
	}

	const tabs = Array.from(root.querySelectorAll('.js-user-tab'));
	const panels = Array.from(root.querySelectorAll('.js-user-panel'));

	tabs.forEach((tab, index) => {
		tab.addEventListener('click', () => {
			tabs.forEach((t, i) => t.classList.toggle('is-active', i === index));
			panels.forEach((p, i) => p.classList.toggle('is-active', i === index));
		});
	});
}

function initOrderFilter() {
	const root = document.querySelector('.js-order-filter');
	if (!root) {
		return;
	}

	const tabs = Array.from(root.querySelectorAll('.c-user__order-of'));
	const rows = Array.from(document.querySelectorAll('.c-user__order-table[data-order-status]'));
	const headerRow = document.querySelector('.c-user__order-table--first');
	const emptyEl = document.querySelector('.js-order-filter-empty');

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			const filter = tab.dataset.filter;
			tabs.forEach((t) => t.classList.toggle('is-active', t === tab));

			let visibleCount = 0;
			rows.forEach((row) => {
				const matches = filter === 'all' || row.dataset.orderStatus === filter;
				row.hidden = !matches;
				if (matches) {
					visibleCount += 1;
				}
			});

			if (headerRow) {
				headerRow.hidden = visibleCount === 0;
			}

			if (emptyEl) {
				emptyEl.hidden = visibleCount !== 0;
			}
		});
	});
}

function showMessage(el, message) {
	if (!el) {
		return;
	}
	el.textContent = message;
	el.hidden = !message;
}

function postAction(action, fields) {
	const body = new URLSearchParams({ action, nonce: window.vbpData.customerNonce, ...fields });
	return fetch(window.vbpData.ajaxUrl, { method: 'POST', body }).then((res) => res.json());
}

// Mirrors checkout-submit.js's busy-button logic — keep both in sync.
function withBusyButton(form, busyLabel, task) {
	const button = form.querySelector('button[type="submit"]');
	const originalLabel = button.textContent;
	button.disabled = true;
	button.textContent = busyLabel;

	return task().finally(() => {
		button.disabled = false;
		button.textContent = originalLabel;
	});
}

function initLoginForm() {
	const form = document.getElementById('login-panel');
	if (!form) {
		return;
	}
	const errorEl = document.getElementById('login-form-error');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		showMessage(errorEl, '');

		withBusyButton(form, 'Đang đăng nhập...', () =>
			postAction('vbp_customer_login', {
				identifier: form.elements.login_identifier.value.trim(),
				password: form.elements.login_password.value,
				remember: form.elements.login_remember.checked ? '1' : '',
			}).then((data) => {
				if (data.success) {
					window.location.href = data.data.redirect;
					return;
				}
				showMessage(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
			})
		).catch(() => showMessage(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.'));
	});
}

function initRegisterForm() {
	const form = document.getElementById('reg-panel');
	if (!form) {
		return;
	}
	const errorEl = document.getElementById('reg-form-error');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		showMessage(errorEl, '');

		withBusyButton(form, 'Đang tạo tài khoản...', () =>
			postAction('vbp_customer_register', {
				name: form.elements.reg_name.value.trim(),
				phone: form.elements.reg_phone.value.trim(),
				email: form.elements.reg_email.value.trim(),
				password: form.elements.reg_password.value,
				password2: form.elements.reg_password2.value,
			}).then((data) => {
				if (data.success) {
					window.location.href = data.data.redirect;
					return;
				}
				showMessage(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
			})
		).catch(() => showMessage(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.'));
	});
}

function initForgotForm() {
	const form = document.getElementById('forgot-panel');
	if (!form) {
		return;
	}
	const errorEl = document.getElementById('forgot-form-error');
	const successEl = document.getElementById('forgot-form-success');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		showMessage(errorEl, '');
		showMessage(successEl, '');

		withBusyButton(form, 'Đang gửi...', () =>
			postAction('vbp_customer_request_reset', {
				email: form.elements.forgot_email.value.trim(),
			}).then((data) => {
				if (data.success) {
					showMessage(successEl, data.data.message);
					form.reset();
					return;
				}
				showMessage(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
			})
		).catch(() => showMessage(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.'));
	});
}

function initResetPasswordForm() {
	const form = document.getElementById('reset-password-form');
	if (!form) {
		return;
	}
	const errorEl = document.getElementById('reset-form-error');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		showMessage(errorEl, '');

		withBusyButton(form, 'Đang xử lý...', () =>
			postAction('vbp_customer_reset_password', {
				login: form.elements.reset_login.value,
				key: form.elements.reset_key.value,
				password: form.elements.reset_password.value,
				password2: form.elements.reset_password2.value,
			}).then((data) => {
				if (data.success) {
					window.location.href = data.data.redirect;
					return;
				}
				showMessage(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
			})
		).catch(() => showMessage(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.'));
	});
}

function initCustomerInfoForm() {
	const form = document.getElementById('customer-info-form');
	if (!form) {
		return;
	}
	const errorEl = document.getElementById('info-form-error');
	const successEl = document.getElementById('info-form-success');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		showMessage(errorEl, '');
		showMessage(successEl, '');

		withBusyButton(form, 'Đang cập nhật...', () =>
			postAction('vbp_customer_update_info', {
				name: form.elements.info_name.value.trim(),
				email: form.elements.info_email.value.trim(),
				phone: form.elements.info_phone.value.trim(),
				address: form.elements.info_address.value.trim(),
			}).then((data) => {
				if (data.success) {
					showMessage(successEl, data.data.message);
					return;
				}
				showMessage(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
			})
		).catch(() => showMessage(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.'));
	});
}

function initVoucherCopyButtons() {
	document.querySelectorAll('[data-copy-code]').forEach((button) => {
		button.addEventListener('click', () => {
			navigator.clipboard?.writeText(button.dataset.copyCode);
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initAuthTabs();
	initUserTabs();
	initOrderFilter();
	initLoginForm();
	initRegisterForm();
	initForgotForm();
	initResetPasswordForm();
	initCustomerInfoForm();
	initVoucherCopyButtons();
});
